/**
 * Skeleton — loading-placeholder shimmer block.
 * Design source: empty-states.jsx:140-157.
 * Atom purity: imports only react + tokens.
 *
 * Note: theme.css has no shimmer keyframes → uses solid S.skeleton color fallback.
 * When shimmer keyframes are added to theme.css, update the background to include
 * the gradient animation — no other change needed.
 */
import { CSSProperties } from 'react';
import { S } from '../../styles/tokens';

export interface SkeletonProps {
  /** Width of the placeholder. Number = px, string = any CSS unit. */
  w?: number | string;
  /** Height in px. */
  h?: number;
  /** Border-radius override in px (ignored for 'circle' variant). */
  r?: number;
  /** Shape variant affecting border-radius. */
  variant?: 'block' | 'text' | 'circle';
  style?: CSSProperties;
}

function resolveRadius(variant: 'block' | 'text' | 'circle', r?: number): number | string {
  if (variant === 'circle') return '50%';
  if (variant === 'text') return r ?? 4;
  return r ?? 8;
}

export function Skeleton({
  w = '100%',
  h = 16,
  r,
  variant = 'block',
  style,
}: SkeletonProps) {
  const base: CSSProperties = {
    width: typeof w === 'number' ? w : w,
    height: h,
    borderRadius: resolveRadius(variant, r),
    background: S.skeleton,
    flexShrink: 0,
    ...style,
  };

  return <div style={base} aria-hidden="true" />;
}
